import type { ReactNode } from 'react';
import { useDeepLinkSite } from '../../hooks/useDeepLinkSite';
import { Loader2 } from 'lucide-react';

interface DeepLinkSiteGateProps {
  children: ReactNode;
}

/**
 * Holds a page back until a deep link's `?site=` has been switched to.
 *
 * CR-6457: wraps pages an emailed count links into (Purchasing), so the page
 * mounts — and reads its own filters from the URL — only once the view shows
 * the linked site. See {@link useDeepLinkSite}.
 */
export default function DeepLinkSiteGate({ children }: DeepLinkSiteGateProps) {
  const ready = useDeepLinkSite();
  if (!ready) {
    return (
      <div className="flex items-center justify-center py-24 text-muted-foreground">
        <Loader2 className="h-6 w-6 animate-spin mr-2" />
        Opening the linked site…
      </div>
    );
  }
  return <>{children}</>;
}
